/** @jsx jsx */
import { jsx } from '@emotion/core';
import { ButtonPrimary } from '@spotify-internal/encore-web';
import { paths } from 'client/shared/Paths';
import { Modal } from '@spotify-internal/anchor-ds';

export function UnpublishEpisodeErrorModal({
  onClose,
  action,
}: {
  onClose: () => void;
  action: 'delete' | 'unpublish';
}) {
  return (
    <Modal
      isShowing
      isShowingCloseButton
      aria-labelledby="unpublish-episode-error-modal-title"
      onClose={onClose}
    >
      <Modal.Title id="unpublish-episode-error-modal-title">
        {`Unable to ${action === 'delete' ? 'delete' : 'unpublish'} episode`}
      </Modal.Title>
      <Modal.Body>
        {action === 'delete' ? 'Deleting' : 'Unpublishing'} this episode would
        leave your RSS feed empty and break your podcast on external platforms.
        If you&apos;d like to delete your podcast, please{' '}
        <a
          href={paths.getHelpPage('home')}
          target="_blank"
          rel="noopener noreferrer"
        >
          get in touch with us
        </a>
        . If you just want to remove this episode, create a new one first.
      </Modal.Body>
      <Modal.Footer>
        <ButtonPrimary onClick={onClose}>Ok, got it</ButtonPrimary>
      </Modal.Footer>
    </Modal>
  );
}
